import { render, staticRenderFns } from "./ods-card.vue?vue&type=template&id=591829c6"
import script from "./ods-card.vue?vue&type=script&lang=js"
export * from "./ods-card.vue?vue&type=script&lang=js"
import style0 from "./ods-card.vue?vue&type=style&index=0&id=591829c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports